import React, { useState, useEffect, useContext } from "react";
import MainLayout from "../../common/layout/MainLayout";
import AddOrder_svg from "../../svg/svg-body/AddOrder_svg";
import Card from "./card/Card";
import "./index.css";
import { path } from "../../constants/apiPath";
import instance from "../../common/api/interceptor";
import Loading from "../loading/Loading";
import { useNavigate } from "react-router-dom";
// import routeConstant from "../../routes/utils/routeConstant";
import NoData from "../noData/NoData";
import { StoreContext } from "../../store";
import { NotificationManager } from "react-notifications";
import exportFromJSON from "export-from-json";
import InfiniteScroll from "react-infinite-scroll-component";
import DocumentSVG from "../../svg/svg-body/DocumentSVG";
import Files from "react-files";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import moment from "moment";
import { LOCAL_STORAGE_KEY, basename } from "../../../config";
import routeConstant from "../../../route/compoent/routeConstant";
import { OrderContext } from "../orderList/store";
import { StoreContext as OldStoreContext } from "../../../store/Provider";

function Dashboard() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const oldContext = useContext(OldStoreContext);
  const [orderBy, setOrderBy] = useState("OD_OrderLastEditedDateUTC");
  const [order, setOrder] = useState("desc");
  // const [inputDisabled, setInputDisabled] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState("");

  const { placedData, setPlacedData } = useContext(OrderContext);
  const { notificationOpen } = useContext(OldStoreContext);
  const [isMount, setIsMount] = useState(false);

  const getDashboardData = async (CurrentPage = 0) => {
    if (CurrentPage === 0) {
      setLoading(true);
    }
    const body = {
      Status: "",
      SortColumnName: orderBy,
      SortDirection: order,
      CurrentPage: CurrentPage,
      PageSize: context.dashBoardBody.pageSize,
    };
    await instance
      .post(`${path.GET_ORDER}`, body)
      .then((res) => {
        if (res.Is_Success) {
          if (CurrentPage === 0) {
            context.setDashboardData(res.data ?? {});
            context.setDashBoardBody((prev) => ({
              ...prev,
              dataLength: prev.dataLength + prev.pageSize,
            }));
          } else {
            let data = res.data?.OrderHeader ?? [];
            context.setDashBoardBody((prev) => ({
              ...prev,
              dataLength: prev.dataLength + prev.pageSize,
            }));
            context.setDashboardData((prev) => ({
              ...prev,
              OrderHeader: [...prev.OrderHeader, ...data],
            }));
          }
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        let hasMorecheck = res.data?.OrderHeader?.length === 10 ? true : false;
        context.setDashBoardBody((prev) => ({
          ...prev,
          hasMore: hasMorecheck,
        }));
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setDashboardData({});
        context.setDashBoardBody({
          page: 0,
          dataLength: 0,
          hasMore: true,
          pageSize: 10,
        });
      });
    context.setDashBoardBody((prev) => ({
      ...prev,
      page: prev.page + 1,
    }));
    setLoading(false);
  };

  const onLoadMore = () => {
    getDashboardData(context.dashBoardBody.page);
  };

  useEffect(() => {
    setIsMount(true);
    if (!Object.keys(context.dashboardData).length) {
      getDashboardData();
    }
  }, []);

  useEffect(() => {
    if (!Object.keys(context.dashboardData).length && isMount) {
      getDashboardData();
    }
  }, [notificationOpen]);

  const onEdit = (orderPK) => {
    context.setBackDropOpen(true);
    instance
      .get(`api/v1/Order/editOrder?orderPk=${orderPK}`)
      .then((res) => {
        if (res.Is_Success) {
          context.setEditOrderJSON(res.data ?? {});
          context.setEditMode(true);
          navigate(routeConstant.EDIT_CREATE_ORDER, {
            state: { edit: true, editOrderJSON: res.data },
          });
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }

        context.setBackDropOpen(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const onDownload = () => {
    context.setBackDropOpen(true);
    const body = {
      Status: "",
      SortColumnName: "",
      SortDirection: "",
      CurrentPage: "",
      PageSize: "",
    };
    instance
      .post(`${path.DOWNLOAD_LOG}`, body)
      .then(async (res) => {
        if (res.Is_Success) {
          const data = res.data;
          const fileName = "Orders List";
          const exportType = exportFromJSON.types.xls;
          await exportFromJSON({ data, fileName, exportType });
          context.setBackDropOpen(false);
        } else {
          NotificationManager.error(res.Message, "", 3000);
          context.setBackDropOpen(false);
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const onFilesChange = (files) => {
    setFiles(files);
    files.length !== 0 && setFileError("");
  };
  const onfileRemove = () => {
    setFiles([]);
  };
  const onDocUpload = async () => {
    if (files.length) {
      context.setBackDropOpen(true);
      const getBase64 = async (file, onLoadCallback) => {
        return await new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      let DocsFileConversion = "";
      var promise = getBase64(files[0]);
      promise.then((result) => {
        DocsFileConversion = `${result.split(";base64,")[0]};base64,`;
        let data = result.split(";base64,")[1];
        let filesizeUnit = files[0].sizeReadable.substr(-2);
        let fileSize = files[0].sizeReadable.split(
          files[0].sizeReadable.substr(-2)
        )[0];
        instance
          .post(path.VALIDATE_EXCEL, {
            FileName: files[0].name,
            FileData: data,
            FileExtention: files[0].extension,
            FileSize: fileSize,
            FileSizeUnit: filesizeUnit,
          })
          .then((res) => {
            // context.setDashboardData({});
            // context.setPlacedOrders({});

            res.data.map((element, index, arr) => {
              if (element.Status === "0") {
                arr[index].Status = "Failed";
              } else {
                arr[index].Status = "Success";
              }
            });

            console.log("Order_upload_log", res.data);
            const data = res.data;
            const fileName = "Order_upload_log";
            const exportType = exportFromJSON.types.xls;
            exportFromJSON({ data, fileName, exportType });

            if (res.Is_Success) {
              setFiles([]);
              NotificationManager.success(res.Message, "", 3000);
            } else {
              NotificationManager.error(res.Message, "", 3000);
            }
            context.setDashBoardBody({
              page: 0,
              dataLength: 0,
              hasMore: true,
              pageSize: 10,
            });
            context.setDashboardData({});
            // context.setPlacedOrders({});
            setPlacedData({ ...placedData, data: [] });
            getDashboardData();

            setFiles([]);
            context.setBackDropOpen(false);
          })
          .catch((err) => {
            console.error(err);
            context.setDashBoardBody({
              page: 0,
              dataLength: 0,
              hasMore: true,
              pageSize: 10,
            });
            context.setDashboardData({});
            setPlacedData({ ...placedData, data: [] });
            getDashboardData();

            if (err.response) {
              NotificationManager.error(err.response.data.Message, "", 3000);
            } else if (err.request) {
            } else if (err.message) {
            } else {
              NotificationManager.error("Something went wrong!", "", 3000);
            }

            context.setBackDropOpen(false);
            if (err?.response?.data?.data) {
              err?.response?.data?.data.map((element, index, arr) => {
                if (element.Status === "0") {
                  arr[index].Status = "Failed";
                } else {
                  arr[index].Status = "Success";
                }
              });
              setTimeout(() => {
                const data = err.response.data.data;
                const fileName = "Order_upload_log";
                const exportType = exportFromJSON.types.xls;
                exportFromJSON({ data, fileName, exportType });
              }, [1500]);
            }
            setFiles([]);
          });
      });
    }
  };
  const onFilesError = (error, file) => {
    NotificationManager.error(error.message, "", 3000);
    setFileError(`Error code ${error.code} : ${error.message}.`);
  };

  const onCardHandler = (orderPk) => {
    // alert(orderPk)
    context.setBackDropOpen(true);

    instance
      .get(`${path.GET_ORDER_DETAIL}?orderPk=${orderPk}`)
      .then((res) => {
        context.setBackDropOpen(false);

        if (res.Is_Success) {
          navigate(routeConstant.DASH_ORDER_LIST_FULL, {
            state: res.data,
          });
        }
      })
      .catch((err) => {
        context.setBackDropOpen(false);

        console.log(err);
      });
  };

  return (
    <div className="_orderDashboard">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-12 order-lg-1 order-2 _orderDashboardLeft">
            <div className="row _orderCardRow">
              <div className="col-12 _orderCardHeadingCol">
                <h6>Orders</h6>
                <div className="_outlineButton">
                  <button onClick={onDownload}>Download Orders</button>
                </div>
              </div>
              <div className="col-12 _orderCardCol">
                {loading ? (
                  <Loading />
                ) : context.dashboardData?.OrderHeader?.length === 0 ||
                  Object.keys(context.dashboardData).length === 0 ? (
                  <NoData>
                    <p>No order found!</p>
                  </NoData>
                ) : (
                  <InfiniteScroll
                    dataLength={context.dashBoardBody.dataLength}
                    next={onLoadMore}
                    hasMore={context.dashBoardBody.hasMore}
                    loader={
                      <div className="_scrollLoader">
                        <Loading />
                      </div>
                    }
                    height={"100%"}
                    endMessage={
                      <p
                        className="_loadNoMore"
                        style={{ textAlign: "center" }}
                      >
                        <b>No more Orders!</b>
                      </p>
                    }
                  >
                    {context.dashboardData?.OrderHeader?.map((ele, index) => (
                      <div
                        className="_dashboardCardBody"
                        key={index}
                        onClick={() => onCardHandler(ele.OrderPK)}
                      >
                        <Card data={ele} onEdit={onEdit} />
                      </div>
                    ))}
                  </InfiniteScroll>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12 order-lg-2 order-1 _orderDashboardRight">
            <div className="row _dashboardOrderStatus">
              <div className="col-12">
                <h6>Order Status</h6>
              </div>
              <div className="col-md-6 col-12">
                <div
                  className="_orderStatusCard"
                  onClick={() => navigate(routeConstant.ORDER_LIST_PLACED)}
                >
                  <div className="_orderStausLabel">Placed Orders</div>
                  <div className="_orderStausValue">
                    {context.dashboardData.OrderStatusType?.Placed?.StatusCount
                      ? context.dashboardData.OrderStatusType?.Placed
                          ?.StatusCount
                      : "0"}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div
                  className="_orderStatusCard"
                  onClick={() => navigate(routeConstant.ORDER_LIST_APPROVED)}
                >
                  <div className="_orderStausLabel">Approved Orders</div>
                  <div className="_orderStausValue">
                    {context.dashboardData.OrderStatusType?.Approved
                      ?.StatusCount
                      ? context.dashboardData.OrderStatusType?.Approved
                          ?.StatusCount
                      : "0"}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div
                  className="_orderStatusCard"
                  onClick={() => navigate(routeConstant.ORDER_LIST_LOADED)}
                >
                  <div className="_orderStausLabel">Loaded Orders</div>
                  <div className="_orderStausValue">
                    {context.dashboardData.OrderStatusType?.Shipped?.StatusCount
                      ? context.dashboardData.OrderStatusType?.Shipped
                          ?.StatusCount
                      : "0"}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div
                  className="_orderStatusCard"
                  onClick={() => navigate(routeConstant.ORDER_LIST_REJECTED)}
                >
                  <div className="_orderStausLabel">Cancelled Orders</div>
                  <div className="_orderStausValue">
                    {context.dashboardData.OrderStatusType?.Cancelled
                      ?.StatusCount
                      ? context.dashboardData.OrderStatusType?.Cancelled
                          ?.StatusCount
                      : "0"}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div
                  className="_orderStatusCard"
                  onClick={() => navigate(routeConstant.ORDER_LIST_ARCHIVE)}
                >
                  <div className="_orderStausLabel">Archived Orders</div>
                  <div className="_orderStausValue">
                    {context.dashboardData.OrderStatusType?.Archived
                      ?.StatusCount
                      ? context.dashboardData.OrderStatusType?.Archived
                          ?.StatusCount
                      : "0"}
                  </div>
                </div>
              </div>
            </div>
            <div className="row _dashOrderCreateNavigate">
              <div className="col-12">
                {oldContext.omsUserData?.UserRoles &&
                oldContext.omsUserData?.UserRoles.includes("Agent") ? (
                  ""
                ) : (
                  <div className="_dashOrderCreateNavigateDiv">
                    <div className="_dashOrderCreateNavigateDivActions">
                      <div className="_solidButton">
                        <a
                          href={`/${basename}/Assets/Files/order_creation_formate.xlsx`}
                          target={"_blank"}
                          download={"order_creation_formate.xlsx"}
                          name={"order_creation_formate.xlsx"}
                        >
                          <button>Download Format</button>
                        </a>
                      </div>
                    </div>
                    {/* <p>Click here to add new order</p>
                      <AddOrder_svg /> */}
                    {files.length === 0 ? (
                      <Files
                        className="files-dropzone _pointer"
                        dragActiveClassName="files-dropzone-active"
                        onChange={onFilesChange}
                        onError={onFilesError}
                        accepts={[".xlsx"]}
                        maxFileSize={1024000}
                        minFileSize={0}
                        clickable
                        multiple={false}
                      >
                        <CloudUploadOutlinedIcon />
                        <p>Drag and Drop Docs Here</p>
                        <span>or</span>
                        <p>Click here to browse Docs</p>
                        <p className="_filemaxInfo">
                          Max. File size should be less than 1MB
                        </p>
                      </Files>
                    ) : (
                      <div className="files-dropzone _filezoneBorder">
                        <div className="_uploadDoc">
                          <div className="_cancelUpload">
                            <button onClick={onfileRemove}>
                              <CancelPresentationIcon />
                            </button>
                          </div>
                          <DocumentSVG colorCode={"#438bc3"} />
                          <p title={files[0].name}>{files[0].name}</p>

                          <div className="_solidButton">
                            <button onClick={onDocUpload}>Upload</button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
